import { setViewportFullHeight } from 'helpers/setViewportFullHeight'
import { useScrollFix } from 'hooks/useScrollFix'
import React, { Suspense, lazy } from 'react'
import { Routes, Route } from 'react-router-dom'
import { routeHistory } from 'route-history'
import { polyfill as smoothScrollPolyfill } from 'smoothscroll-polyfill'
import { Spinner } from './Spinner'
import { CustomRouter } from './CustomRouter'
import { SubscribeFlow } from './SubscribeFlow'
import { useInitFirebase } from 'hooks/useInitFirebase'
import { useInitGrowthbook } from 'hooks/useInitGrowthbook'
import { useAxonPixelEvent } from 'hooks/useAxonPixelInitialization'

const PrivacyPolicy = lazy(() =>
  import('../pages/PrivacyPolicy').then((m) => ({ default: m.PrivacyPolicy })),
)
const TermsOfUse = lazy(() =>
  import('../pages/TermsOfUse').then((m) => ({ default: m.TermsOfUse })),
)

setViewportFullHeight()
smoothScrollPolyfill()

export const App: React.FC = () => {
  useInitFirebase()
  useInitGrowthbook()
  useScrollFix()
  useAxonPixelEvent()

  return (
    <CustomRouter history={routeHistory}>
      <Suspense fallback={<Spinner />}>
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/*" element={<SubscribeFlow />} />
        </Routes>
      </Suspense>
    </CustomRouter>
  )
}
